export default {
    accountLogin: "Login da conta",
    accountNumber: "Número de conta",
    password: "Palavra-passe",
    egateeWebsite: "Site oficial do Egatee",
    iosDownloadIsNotCurrentlySupportedSoStayTuned: "{0} No momento, o aplicativo não é compatível com a versão iOS, portanto, fique atento!",
    suggestion: "Sugestão",
    downloadBuyerApp: "Baixe o aplicativo Egatee",
    aboutUs: "Sobre nós",
    china: "China",
    CoteDivoire: "Costa do Marfim",
    uganda: "Uganda",
    goDownloadEgateeAPP: "Vá baixar o aplicativo Egatee",
    downloadAPP: "Baixe o aplicativo {0}",
    downloadAppOnGP: "Faça o download do aplicativo {0} no Google play",
    scanQrCode: "Digitalize o código QR",
    downloadAppOnAppStore: "Baixe o aplicativo {0} na App Store"
}